
import isReachable from 'is-reachable';

import CheckIP from './Check-IP';
//import isOnline from 'is-online';


export default async function CheckVPN(): Promise<boolean> {
    console.log("Ejecutando CheckVPN");

    let Resultado: boolean = true;

    let host = 'https://172.20.6.118';


    try {

        Resultado = await CheckIP(host);

    } catch (error) {
        console.error("Error en CheckVPN:", error);
        Resultado = false;
    }

    console.log("Resultado: " + Resultado);


    return Resultado;
}